<!--
 * @Description: 新增上报配件（安装设备更换）
 * @Author: luohuan
 * @Date: 2025-09-05 14:46:30
 * @LastEditTime: 2025-09-05 14:46:30
 * @LastEditors: luohuan
-->
<template>
  <el-dialog
    v-dialogDrag
    :title="editType == 2 ? '编辑' : editType == 1 ? '新增' : '详情'"
    :visible="addVisible"
    width="700px"
    :close-on-click-modal="false"
    v-loading="dialogLoading"
    :element-loading-background="loadingBackground"
    :before-close="handleClose"
    custom-class="install-scene-dialog"
  >
    <el-form
      label-width="120px"
      ref="addForm"
      :model="addForm"
      :rules="addFormRules"
    >
      <el-form-item label="工单类型" prop="workOrderTypeList">
        <e6-vr-select
          v-model="addForm.workOrderTypeList"
          :data="workOrderTypeList"
          placeholder="工单类型"
          title="工单类型"
          clearable
          :props="{
            id: 'codeValue',
            label: 'codeName'
          }"
          multiple
          :disabled="editType === 3"
        ></e6-vr-select>
        <template v-if="editType === 3">
          {{ this.workOrderTypeNameList }}
        </template>
      </el-form-item>

      <el-form-item label="主机类型" class="search-item--1" prop="productCode">
        <e6-vr-select
          is-title
          placeholder="产品名称"
          title="产品名称"
          :data="productList"
          ref="select"
          v-model="addForm.productCode"
          clearable
          :props="{
            id: 'productCode',
            label: 'productName'
          }"
          :disabled="editType === 3"
        >
        </e6-vr-select>
      </el-form-item>

      <el-form-item label="是否启用" prop="status">
        <el-switch
          v-model="addForm.status"
          :active-value="1"
          :inactive-value="0"
          :disabled="editType === 3"
        >
        </el-switch>
      </el-form-item>
    </el-form>
    <div>
      <!-- 工单类型+具体耗材 -->
      <el-table
        border
        :data="tableData"
        highlight-current-row
        ref="selectTable"
      >
        <el-table-column
          show-overflow-tooltip
          v-for="(column, index) in columnData"
          :key="index"
          :prop="column.fieldName"
          :label="column.fieldLabel"
          :min-width="column.width"
          :align="column.align"
          header-align="center"
        >
          <template slot-scope="{ row }">
            <!-- <div v-if="column.fieldName === 'bizNoList	 '">
              <e6-vr-select
                v-model="row.bizNoList"
                :data="consumeMasterTypeList"
                placeholder="主机类型"
                title="主机类型"
                clearable
                :props="{
                  id: 'codeValue',
                  label: 'codeName'
                }"
                multiple
                 :disabled="editType === 3"
              ></e6-vr-select>
            </div> -->
            <div v-if="column.fieldName === 'materialNo'">
              <remote-search
                v-model="row.materialNo"
                :remote="true"
                :disabled="editType === 3"
                clearable
                placeholder="耗材名称"
                title="耗材名称"
                :searchData="{
                  materialTypes: [408702, 408703],
                  isEnableEquipNo:false,
                  pageIndex: 1,
                  pageSize: 200
                }"
                @change="
                  (val, node) => {
                    changeMaterialNo(val, node, row);
                  }
                "
                :defaultValue="
                  editType == 1
                    ? {}
                    : {
                        materialName: row.materialName,
                        materialNo: row.materialNo
                      }
                "
                :showInit="editType == 1 ? true : false"
              ></remote-search>
            </div>
            <div v-else-if="column.fieldName === 'amount'">
              <el-input
                v-model="row.amount"
                :disabled="editType === 3"
              ></el-input>
            </div>
            <span v-else>{{ row[column.fieldName] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          show-overflow-tooltip
          align="center"
          header-align="center"
          min-width="90"
        >
          <template slot-scope="{ row, $index }" v-if="editType != 3">
            <i
              class="e6-icon-add_line1"
              title="新增"
              @click="handleAdd(row, $index)"
            ></i>
            <i
              class="e6-icon-clear_fill"
              title="删除"
              @click="deleteColumn($index, row)"
            ></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button class="cancel" @click="handleClose">取消</el-button>
      <el-button type="primary" @click="confirm" v-if="editType != 3"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import base from "@/mixins/base";
import { printError } from "@/utils/util";
import {
  queryProductList,
  addReportPart,
  updateReportPart,
  getReportPart
} from "@/api";
import { handler } from "../../../../../api";
export default {
  name: "add",
  components: {},
  data() {
    return {
      handler,
      queryProductList,
      dialogLoading: false,
      productList: [], //产品列表
      workOrderTypeNameList: [],
      addForm: {
        productCode: "",
        productName: "",
        status: 1,
        workOrderTypeList: []
      },
      addFormRules: {
        productCode: [
          {
            required: true,
            message: "请选择产品",
            trigger: ["blur", "change"]
          }
        ],
        workOrderTypeList: [
          {
            required: true,
            message: "请选择工单类型",
            trigger: ["blur", "change"]
          }
        ]
      },
      columnData: [
        {
          fieldName: "materialNo",
          fieldLabel: "物料名称",
          width: 200,
          fixed: false,
          align: "center"
        },
        {
          fieldName: "materialNoStr",
          fieldLabel: "物料编码",
          width: 100,
          fixed: false,
          align: "center"
        },
        {
          fieldName: "amount",
          fieldLabel: "上报上限",
          width: 100,
          fixed: false,
          align: "center"
        }
      ],
      tableData: [
        {
          materialNo: "",
          materialNoStr: "",
          amount: "",
          bizNoList: []
        }
      ]
    };
  },
  props: [
    "addVisible",
    "workOrderTypeList",
    "detailInfo",
    "editType"
  ],
  mixins: [base],
  computed: {},
  watch: {
    addVisible: {
      immediate: true,
      handler(val) {
        if (
          val &&
          (this.editType == 2 || this.editType == 3 || this.editType == 4)
        ) {
          // let {
          //   productCode,
          //   productName,
          //   workOrderTypeList,
          //   workOrderTypeNameList,
          //   status,
          //   equipReplaceId
          // } = this.detailInfo;
          // let TypeList = workOrderTypeList.map(item => {
          //   item = item + "";
          //   return item;
          // });
          
          // if (this.editType == 2) {
          //   this.addForm.equipReplaceId = equipReplaceId;
          // }
          
          // this.addForm.productCode = productCode;
          // this.addForm.workOrderTypeList = TypeList;
          // this.addForm.status = status;
          // this.addForm.productName = productName;
          // this.workOrderTypeNameList = workOrderTypeNameList;
          this.getDetail();
        }
      }
    },
    "addForm.productCode": {
      immediate: true,
      handler(val) {
        if (val) {
          // 查找选中的产品对象
          const selectedProduct = this.productList.find(
            item => item.productCode === val
          );

          // 更新产品名称
          this.addForm.productName = selectedProduct
            ? selectedProduct.productName
            : "";
        } else {
          this.addForm.productName = "";
        }
      }
    }
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      let promiseList = [
        queryProductList({
          productName: "",
          productAttributesList: [1, 3], // 便携，安装
          statusList: [1], // 已上架
          productTypeList: [1] //主机
        })
      ];
      let [productRes] = await Promise.all(promiseList);
      //产品列表
      this.productList = this.getFreezeResponse(productRes, {
        path: "data"
      });
    },
    async getDetail() {
      try {
        this.dialogLoading = true;
        let res = await getReportPart({
          id: this.detailInfo.equipReplaceId
        });
        if (res.code == "OK") {
          let materialVOList = res.data.materialVOList;
          materialVOList.map(item => {
            item.materialNoStr = item.materialNo;
          });
          this.tableData = materialVOList;

          let {
            productCode,
            productName,
            workOrderTypeList,
            workOrderTypeNameList,
            status,
            equipReplaceId
          } = res.data;
          let TypeList = workOrderTypeList.map(item => {
            item = item + "";
            return item;
          });
          
          if (this.editType == 2) {
            this.addForm.equipReplaceId = equipReplaceId;
          }
          
          this.addForm.productCode = productCode;
          this.addForm.workOrderTypeList = TypeList;
          this.addForm.status = status;
          this.addForm.productName = productName;
          this.workOrderTypeNameList = workOrderTypeNameList;

        }
      } catch (error) {
        printError(error);
      } finally {
        this.dialogLoading = false;
      }
    },
    changeMaterialNo(val, node, row) {
      row.materialNoStr = node.materialNo;
    },
    changeType() {
      this.tableData = [
        {
          materialNo: "",
          materialNoStr: "",
          amount: ""
        }
      ];
    },
    //点击确定
    confirm() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          let tableData = this.tableData;
          if (tableData.some(item => !item.materialNo)) {
            this.$message.warning("请检查耗材名称是否全部选择");
            return;
          }
          if (tableData.some(item => !item.amount)) {
            this.$message.warning("请检查上报上限是否全部输入");
            return;
          }
          if (this.editType == 2) {
            this.updateReportPartReq();
          } else {
            this.addReportPartReq();
          }
        }
      });
    },
    //新增
    async addReportPartReq() {
      try {
        this.dialogLoading = true;
        let res = await addReportPart({
          ...this.addForm,
          materialVOList: this.tableData
        });
        if (res.code == "OK") {
          this.$message.success("添加成功");

          this.$emit("refresh");
          this.handleClose();
        }
      } catch (error) {
        printError(error);
      } finally {
        this.dialogLoading = false;
      }
    },
    //关闭弹框
    handleClose() {
      this.addForm = {
        productCode: "",
        productName: "",
        equipReplaceId: "",
        status: 1,
        workOrderTypeList: []
      };
      this.tableData = [
        {
          materialNo: "",
          materialNoStr: "",
          amount: ""
        }
      ];
      this.$emit("close", "addVisible");
    },
    //编辑
    async updateReportPartReq() {
      try {
        this.dialogLoading = true;
        let res = await updateReportPart({
          ...this.addForm,
          materialVOList: this.tableData
        });
        if (res.code == "OK") {
          this.$message.success("编辑成功");
          this.$emit("refresh");
          this.handleClose();
        }
      } catch (error) {
        printError(error);
      } finally {
        this.dialogLoading = false;
      }
    },
    //点击添加
    handleAdd() {
      let tableData = this.tableData;
      tableData.push({
        materialNo: "",
        materialNoStr: "",
        amount: ""
      });
      this.tableData = tableData;
    },
    //删除单行
    deleteColumn(index) {
      let tableData = _.cloneDeep(this.tableData);
      tableData.splice(index, 1);
      this.tableData = tableData;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.install-scene-dialog {
  .el-dialog__body {
    padding-top: 20px;
    [class^="e6-icon"] {
      height: 28px;
      color: #46bfea;
      line-height: 28px;
      font-style: normal;
      text-align: center;
      padding: 0 10px;
      cursor: pointer;
      border-radius: 3px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 28px;
      padding: 0;
      font-size: 20px;
    }
  }
}
</style>
